export default "__VITE_ASSET__DAQ59e4m__"